import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const PaymentStatus = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Normalize query param key (handles status=SUCCESS, STATUS=success, etc.)
  const getNormalizedParam = (key) => {
    const entries = [...searchParams.entries()];
    const match = entries.find(([k]) => k.toLowerCase() === key.toLowerCase());
    return match ? match[1] : null;
  };

  const status = getNormalizedParam('status')?.toLowerCase();
  // const orderId = getNormalizedParam('id');

  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    fontFamily: 'Segoe UI, Roboto, sans-serif',
    background: '#f6f6f6',
  };

  const popupStyle = {
    backgroundColor: '#ffffff',
    padding: '40px',
    borderRadius: '16px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
    textAlign: 'center',
    width: '400px',
  };

  const iconHeadingStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    fontSize: '22px',
    fontWeight: 'bold',
    marginBottom: '12px',
  };

  // const orderTextStyle = {
  //   marginBottom: '16px',
  //   fontSize: '16px',
  // };

  const statusStyle = {
    fontSize: '18px',
    marginBottom: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
  };

  const successStyle = { ...statusStyle, color: '#28a745' };
  const failureStyle = { ...statusStyle, color: '#dc3545' };
  const abortedStyle = { ...statusStyle, color: '#ff8c00' };
  const defaultStyle = { ...statusStyle, color: '#6c757d' };

  const buttonStyle = {
    padding: '12px 20px',
    fontSize: '16px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: '#007bff',
    color: '#ffffff',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    transition: 'background-color 0.3s ease',
  };

  const handleGoBack = () => {
    navigate('/payment');
  };

  return (
    <div style={containerStyle}>
      <div style={popupStyle}>
        <div style={iconHeadingStyle}>
          <span>Payment Status</span>
        </div>

        {/* <p style={orderTextStyle}>
          <strong>🧾 Order ID:</strong> {orderId}
        </p> */}

        {status === 'success' && (
          <div style={successStyle}>✅ Payment Successful!</div>
        )}
        {status === 'failure' && (
          <div style={failureStyle}>❌ Payment Failed!</div>
        )}
        {status === 'aborted' && (
          <div style={abortedStyle}>⚠️ Payment Aborted!</div>
        )}
        {!['success', 'failure', 'aborted'].includes(status) && (
          <div style={defaultStyle}>⏳ Waiting for payment result...</div>
        )}

        <button
          style={buttonStyle}
          onClick={handleGoBack}
          onMouseOver={(e) => (e.target.style.backgroundColor = '#0056b3')}
          onMouseOut={(e) => (e.target.style.backgroundColor = '#007bff')}
        >
          🔙 Go Back
        </button>
      </div>
    </div>
  );
};

export default PaymentStatus;
